import { createSelector } from "@ngrx/store";
import { IRootState } from "../../../store";
import { ActionTypes, TypeAction } from "./mvr-check.actions";

export interface IState {
    status: any;
    message: string | null;
    startedAt: Date | null;
  }


  const initialState: IState = {
    status: null,
    message: null,
    startedAt: null,
  };

  export function mvrCheckReducer(state: IState = initialState, action: TypeAction): IState {
    const { type, payload } = action;
  
    switch (type) {
      case ActionTypes.STORE_MVR_CHECK_STATUS: {
        return Object.assign({}, state, payload);
      }
  
      default: {
        return state;
      }
    }
  }

export const getMvrCheckStatusNumber = createSelector(
    (root: IRootState): IState => root.mvrCheck,
    ({ status }: IState): number => status
  );